import React, { useEffect } from "react";
import ctl from "@netlify/classnames-template-literals";

import { Container, Ntext } from "components";
import { benefitsSection, quoteSection } from "config/drivers";
import QuoteOpen from "svgs/drivers/quote-open.svg";

import { BenefitPane } from "./benefit-pane";

const { title, benefits } = benefitsSection;
const { quoteText, quoteAuthor, quoteAuthorCompany } = quoteSection;

const DriverBenefitsWithQR = () => {
  useEffect(() => {
    const quoteBlock = document.getElementById("quote-block");
    const quoteText = document.getElementById("quote-text");
    const quoteBlockObserver = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        quoteBlock.classList.remove("animate-slideAndReveal");
        quoteText.classList.remove("animate-fadeInLater");
      } else {
        quoteBlock.classList.add("animate-slideAndReveal");
        quoteText.classList.add("animate-fadeInLater");
      }
    });

    quoteBlockObserver.observe(quoteBlock);

    return () => {
      quoteBlockObserver.unobserve(quoteBlock);
    };
  }, []);
  return (
    <section className={wrapperStyle}>
      <Container className="flex flex-col space-y-[96px] w-full items-center">
        <Ntext
          value={title}
          color="primary-100"
          className="!font-medium md:!text-[56px] md:!leading-[64px] !-tracking-[2px] lg:min-h-[132px] text-center"
          variant="h1"
        />
        <section className={benefitsStyle}>
          {benefits.map(benefit => (
            <BenefitPane key={benefit.title} {...benefit} />
          ))}
        </section>
        <article className={quoteWrapperStyle}>
          <QuoteOpen />
          <article className="flex flex-col space-y-5">
            <section id="quote-block" className={quoteBlockStyle}>
              <Ntext
                id="quote-text"
                value={quoteText}
                color="n-platinum"
                className="!font-normal !-tracking-[0.8px]"
                variant="h3"
              />
            </section>
            <div className="flex items-baseline">
              <Ntext
                value={quoteAuthor + ","}
                className="!font-bold !-tracking-[0.8px]"
                variant="text5"
                color="n-grey0"
              />
              &nbsp;{" "}
              <Ntext
                value={quoteAuthorCompany}
                className="!font-medium !-tracking-[0.8px]"
                variant="text5"
                color="n-grey0"
              />
            </div>
          </article>
        </article>
      </Container>
    </section>
  );
};

const benefitsStyle = ctl(`
  grid
  lg:flex
  grid-cols-1
  md:grid-cols-2
  lg:justify-between
  grid-flow-row
  mx-auto
  gap-10
  w-full
`);

const wrapperStyle = ctl(`
  bg-n-smoky
  overflow-clip
  lg:pt-[200px]
  lg:pb-[164px]
  py-[100px]
  w-screen
  relative
`);

const quoteWrapperStyle = ctl(`
  flex
  flex-col
  lg:flex-row
  lg:space-x-4
  lg:space-y-0
  my-[100px]
  space-y-2
  lg:my-40
`);

const quoteBlockStyle = ctl(`
  rounded
  bg-[length:200%_100%]
  bg-gradient-to-r
  from-transparent
  to-secondary
  from-50%
  to-50%
`);

export { DriverBenefitsWithQR };
